import { ModalOptions } from './types';

export interface OpenModalAction {
  type: 'MODAL/OPEN';
  payload: {
    name: string;
    options: ModalOptions;
  };
}
export function openModal(name: string, options?: ModalOptions): OpenModalAction {
  return {
    type: 'MODAL/OPEN',
    payload: {
      name,
      options: options || {},
    },
  };
}

export interface CloseModalAction {
  type: 'MODAL/CLOSE';
  payload: {
    name: string;
  };
}
export function closeModal(name: string): CloseModalAction {
  return {
    type: 'MODAL/CLOSE',
    payload: {
      name,
    },
  };
}

export interface UpdateModalAction {
  type: 'MODAL/UPDATE';
  payload: {
    options?: ModalOptions;
  };
}
export function updateModal(options?: ModalOptions): UpdateModalAction {
  return {
    type: 'MODAL/UPDATE',
    payload: {
      options,
    },
  };
}

export type ModalAction = OpenModalAction | CloseModalAction | UpdateModalAction;
